import Shop from '@/tests/mocks/shop'
import ShopOrders from '@/tests/mocks/shop-orders'
import ShopOrdersByCustomer from '@/tests/mocks/orders-sort-customer'
import CustomersForPicker from '@/tests/mocks/customers-for-picker'
import AvailabilitiesForPicker from '@/tests/mocks/availabilities-for-picker'
import ItemsForPicker from '@/tests/mocks/items-for-picker'
import PatchShopOrder from '@/tests/mocks/patch-shop-order'
import MockAdapter from 'axios-mock-adapter'
import { MM_API_BASE_URL } from '@/constants/credentials'

export default (Laravel) => {
  // console.log('Mocking Laravel.')
  const mock = new MockAdapter(Laravel, {
    onNoMatch: 'passthrough',
    delayResponse: 1200,
  })

  const baseUrl = MM_API_BASE_URL

  mock.onGet(`${baseUrl}/validate-token`).reply(200, {
    email: 'test@gmail.com',
    token: 'cq84j4z44bjdmQmGtQ2qp2zFeydzxOhLjyOCQ1xNLJDkLZZE1jDoP2oujIEI',
    status: 'ACTIVE',
    expires_at: '2022-01-11 07:43:31',
  })

  // Mock a customer w/no email or pass
  // mock.onPost(`${baseUrl}/user-code/verify/`).reply(200, {
  //   verified: true,
  //   email: '',
  //   pass: false,
  //   token: 'Z5pbvE4VJYdZlyhxc0nlCxd4fd9TvaJv2hc3JUdQCEWnyR8dzRJjs0DFnq87',
  //   expires_at: '2022-01-11 22:27:20',
  // })

  // Mock a customer w/an email but no pass
  mock.onPost(`${baseUrl}/user-code/verify/`).reply(200, {
    verified: true,
    email: 'n********@g***com',
    pass: false,
    token: 'Z5pbvE4VJYdZlyhxc0nlCxd4fd9TvaJv2hc3JUdQCEWnyR8dzRJjs0DFnq87',
    expires_at: '2023-01-11 22:27:20',
  })

  mock.onPost(`${baseUrl}/legacy-customer/update`).reply(200, {
    id: 8,
    first_name: 'Newly',
    last_name: 'Updated',
    phone: '55512345467',
    phone_normalized: '55512345467',
    phone_verified_at: '2022-01-11T22:40:25.000000Z',
    street: '7363 Lilliana Point Apt. 684',
    zip: '98307',
    email: 'legacy.custy@gmail.com',
    email_verified_at: '2022-01-11T19:10:12.000000Z',
    is_merchant: false,
    is_super_admin: false,
    payment_service: null,
    payment_handle: null,
    api_token: '9MxCS1VBDvjcQybEFZ5b6IQ7CshaqjvwbWii7e7pUX1DsbePoUJd8EQO4AAr',
    api_token_refreshed_at: '2022-01-11T22:40:36.000000Z',
    status: 'ACTIVE',
    airtable_id: null,
    remember_token: '0bopzsmN31',
    created_at: '2022-01-11T19:10:12.000000Z',
    updated_at: '2022-01-11T22:40:36.000000Z',
    deleted_at: null,
    shop_id: null,
  })

  mock.onGet(`${baseUrl}/shops/slug/verbenacafe`).reply(200, Shop)
  mock.onGet(`${baseUrl}/shops/2`).reply(200, Shop)
  mock.onPost(`${baseUrl}/shops/2/login`).reply(200, {
    data: {
      id: 1,
      first_name: 'Minimart',
      last_name: 'Admin',
      phone: '573-898-5837',
      phone_normalized: '5738985837',
      phone_verified_at: '2022-01-15T18:45:35.000000Z',
      street: null,
      zip: null,
      email: 'hi@getminimart.com',
      email_verified_at: '2022-01-15T18:45:35.000000Z',
      is_merchant: false,
      is_super_admin: true,
      payment_service: null,
      payment_handle: null,
      notes: null,
      status: 'ACTIVE',
      created_at: '2022-01-15T18:45:35.000000Z',
      updated_at: '2022-01-15T19:53:24.000000Z',
      deleted_at: null,
      shop_id: 1,
      stripe: { last_four: null, id: null, customer_id: null },
      token: 'H6K27eLcklG4RClJwW6csnaAM3HSTBwE82EQsUfbsPkPcn1dR2CkcplYa4U5',
      expires_at: '2023-01-15 21:53:24',
    },
  })
  mock
    .onGet(`${baseUrl}/shops/2/orders?page=1&per_page=25`)
    .reply(200, ShopOrders)
  mock
    .onGet(`${baseUrl}/shops/2/orders?page=1&per_page=25&sort=customer_id`)
    .reply(200, ShopOrdersByCustomer)
  mock
    .onGet(`${baseUrl}/shops/2/customers?per_page=100`)
    .reply(200, CustomersForPicker)
  mock
    .onGet(`${baseUrl}/shops/2/availabilities?per_page=100`)
    .reply(200, AvailabilitiesForPicker)
  mock.onGet(`${baseUrl}/shops/2/items?per_page=100`).reply(200, ItemsForPicker)
  mock.onPatch(`${baseUrl}/shops/2/orders/27`).reply(200, PatchShopOrder)
}
